import { Component, Inject} from '@angular/core';
import { FileRecordObject } from '../records/file-record';
import { FileRecordService } from '../records/file-record.service';
import { SessionService } from '../session/session.service';
import { NmdpWidget } from '@nmdp/nmdp-login';

@Component({
  selector: 'home-component',
  templateUrl: './home.component.html',
  styleUrls: [ './home.component.css' ],
  providers: [SessionService]
})
export class HomeComponent  {
  activeFileRecordList: FileRecordObject[] = new Array<FileRecordObject>();
  previousFileRecordList: FileRecordObject[] = new Array<FileRecordObject>();
  name = 'Angular';
  session = null;
  constructor(@Inject(NmdpWidget) private readonly loginWidget: NmdpWidget,
              private readonly fileRecordService: FileRecordService,
              private readonly sessionService: SessionService) {
      this.sessionService.sessionInit().then(response => {
        this.session = localStorage.getItem('session');
        this.updateTableData();
      });
  }


public updateTableData(): void {
    this.fileRecordService.getSessionTableContent().then(fileRecords =>  {
      if (fileRecords) {
        this.activeFileRecordList = this.fileRecordService.toFileRecordObjectList(fileRecords);
    }});
    if (this.loginWidget.lastName !== 'UploaderGuest') {
      this.fileRecordService.getHistoryTableContent().then(fileRecords =>  {
        if (fileRecords) {
          this.previousFileRecordList = this.fileRecordService.toFileRecordObjectList(fileRecords);
        }});
    }
  }
}
